import { defineElement } from '@webtides/element-js';
import DiscountField from './discount-field.class';
defineElement('discount-field', DiscountField);
